export default class Payload {
    constructor(type, payload, signature) {
        this.type = type;
        this.payload = payload;
        this.signature = signature;
    }
    static parse(data) {
        const { type, payload, signature } = JSON.parse(data);
        return new Payload(type, payload, signature);
    }
}
